module.exports = __webpack_public_path__ + "static/assets/f3eebf3dbf52d3ba97c9176807aa32ad.gif";